module.exports = "\r\n<!--\r\n<div>\r\n\tHOLA\r\n</div>\r\n-->\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/geoposicionamiento/geoposicionar.component.html
// module id = ../../../../../src/app/componentes/geoposicionamiento/geoposicionar.component.html
// module chunks = main